import Vue from 'vue';
import Vuex from 'vuex';
import api from './api';
import common from './common';
import cam from './cam';
import server from './server';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        common,
        api,
        cam,
        server
    }
})
